import PersonIcon from "@mui/icons-material/PersonOutlined";
import { Avatar } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useTheme } from "../context/ThemeContext";

/** How strongly the tile of a client is washed with the primary colour. */
const CLIENT_TINT_ALPHA = 0.1;

/**
 * The tile a party's name starts with. A client's is washed with the primary
 * colour, so the clients stand out among the parties at a glance.
 */
export const PartyAvatar = ({ client = false }: { client?: boolean }) => {
  const { theme } = useTheme();

  return (
    <Avatar
      variant="rounded"
      sx={{
        width: theme.spacing(4.75),
        height: theme.spacing(4.75),
        borderRadius: 2.25,
        bgcolor: client
          ? alpha(theme.palette.primary.main, CLIENT_TINT_ALPHA)
          : theme.palette.action.hover,
        color: client ? "primary.main" : "text.secondary",
      }}
    >
      <PersonIcon fontSize="small" />
    </Avatar>
  );
};
